export class AccountDTO {
  constructor(
    public firstName: string,
    public lastName: string,
    public status: string,
    public organizations: OrganizationDTO[],
    public id?: string,
    public externalRef?: string,
    public email?: string,
    public title?: string,
    public organizationId?: string,
    public leadershipFlag?: boolean,
    public districtSchoolTitle?: string,
  ) { }
}

export class OrganizationDTO {
  constructor(public id: string, public roleId: string, public includeChilds?: boolean) { }
}
